import type { Follow } from 'types/following';

const asSubEventMap = (follows: Follow[]): Record<number, Follow[]> =>
  follows.reduce(
    (acc, follow) => {
      acc[follow.subEventId] = [...(acc[follow.subEventId] || []), follow];
      return acc;
    },
    {} as Record<number, Follow[]>
  );

export default asSubEventMap;
